package com.milta.feature.profile.presentation

enum class PhoneChangeStep { Number, Otp }
enum class DeleteAccountStep { Confirm, Otp }

data class ProfileState(
    val isLoading: Boolean = false,
    val firstName: String = "",
    val lastName: String = "",
    val phoneNumber: String = "",
    val language: String? = null,
    val roles: List<String> = emptyList(),
    // Change language dialog
    val showLanguageDialog: Boolean = false,
    val selectedLanguage: String = "",
    val isLanguageSaving: Boolean = false,
    // Change phone number dialog
    val showPhoneDialog: Boolean = false,
    val phoneStep: PhoneChangeStep = PhoneChangeStep.Number,
    val phoneDialCode: String = "+32",
    val phoneLocalNumber: String = "",
    val pendingPhoneNumber: String = "",
    val otpInput: String = "",
    val isPhoneRequestSaving: Boolean = false,
    val isPhoneConfirmSaving: Boolean = false,
    // Delete account dialog
    val showDeleteDialog: Boolean = false,
    val deleteStep: DeleteAccountStep = DeleteAccountStep.Confirm,
    val deleteOtpInput: String = "",
    val isDeleteRequestSaving: Boolean = false,
    val isDeleteConfirmSaving: Boolean = false,
    // Feedback
    val linkedCode: String = "",
    val linkCodeLoadFailed: Boolean = false,
    val codeCopied: Boolean = false,
    val error: String? = null,
    val successMessage: String? = null,
)
